import { Component, Input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { RouterLink, RouterLinkActive } from "@angular/router";

@Component({
    selector: "bottom-navigation",
    imports: [MatIcon, RouterLink, RouterLinkActive],
    templateUrl: "./bottom-navigation.html",
    styleUrl: "./bottom-navigation.scss"
})
export class BottomNavigation {
    @Input() public menuItems: { label: string; icon: string; route: string; id?: string }[] = [];
}
